import type { IconName } from '@hotjar/hotsauce';

export enum CardConfigIds {
  MANUAL = 'manual',
  NPM = 'npm',
  PLATFORMS = 'platforms',
  SHARE = 'share',
}

export interface SmallCardsConfig {
  id: CardConfigIds;
  title: string;
  description: string;
  ctaText: string;
  icon: IconName;
  enabled?: boolean;
}

export const SMALL_CARDS_MAP: { [id in CardConfigIds]: SmallCardsConfig } = {
  [CardConfigIds.MANUAL]: {
    id: CardConfigIds.MANUAL,
    title: 'activation:setup-wizard.main-page.cards.manual.title',
    description: 'activation:setup-wizard.main-page.cards.manual.description',
    ctaText: 'activation:setup-wizard.main-page.cards.manual.cta',
    icon: 'code',
    enabled: true,
  },
  [CardConfigIds.NPM]: {
    id: CardConfigIds.NPM,
    title: 'activation:setup-wizard.main-page.cards.npm.title',
    description: 'activation:setup-wizard.main-page.cards.npm.description',
    ctaText: 'activation:setup-wizard.main-page.cards.npm.cta',
    icon: 'npm',
    enabled: true,
  },
  [CardConfigIds.PLATFORMS]: {
    id: CardConfigIds.PLATFORMS,
    title: 'activation:setup-wizard.main-page.cards.platforms.title',
    description: 'activation:setup-wizard.main-page.cards.platforms.description',
    ctaText: 'activation:setup-wizard.main-page.cards.platforms.cta',
    icon: 'puzzle',
    enabled: true,
  },
  [CardConfigIds.SHARE]: {
    id: CardConfigIds.SHARE,
    title: 'activation:setup-wizard.main-page.cards.share.title',
    description: 'activation:setup-wizard.main-page.cards.share.description',
    ctaText: 'activation:setup-wizard.main-page.cards.share.cta',
    icon: 'forward',
    enabled: true,
  },
};

export const SMALL_CARDS_LIST = [
  SMALL_CARDS_MAP[CardConfigIds.MANUAL],
  SMALL_CARDS_MAP[CardConfigIds.NPM],
  SMALL_CARDS_MAP[CardConfigIds.PLATFORMS],
  SMALL_CARDS_MAP[CardConfigIds.SHARE],
];
